import { Mapper } from 'src/base/mapper'
import { CheckDuplicateEmailTypeEntity } from 'src/data/entities/register.entity'
import { CheckDuplicateEmailTypeModel } from 'src/domain/models/register.model'

export class CheckDuplicateEmailMapper extends Mapper<CheckDuplicateEmailTypeEntity, CheckDuplicateEmailTypeModel> {
	mapFrom(param: CheckDuplicateEmailTypeEntity): CheckDuplicateEmailTypeModel {
		return this.resultData(param)
	}

	mapTo(param: CheckDuplicateEmailTypeModel): CheckDuplicateEmailTypeEntity {
		return this.resultData(param)
	}

	resultData(param: CheckDuplicateEmailTypeEntity | CheckDuplicateEmailTypeModel) {
		return {
			data: param.data,
			status: param.status,
		}
	}
}
